import { useId, useState, type ReactNode } from "react"
import { ChevIcon } from "./icons"

/** "Read more" style toggle from nira.html: a teal text button with a chevron and a quiet panel. */
export function Fold({ label, children, defaultOpen = false }: { label: ReactNode; children: ReactNode; defaultOpen?: boolean }) {
  const [open, setOpen] = useState(defaultOpen)
  const [touched, setTouched] = useState(false)
  const id = useId()
  return (
    <>
      <p>
        <button
          type="button"
          className="dx"
          aria-expanded={open}
          aria-controls={id}
          onClick={() => {
            setTouched(true)
            setOpen((o) => !o)
          }}
        >
          {label}
          <ChevIcon />
        </button>
      </p>
      <div className={touched ? "panel in" : "panel"} id={id} hidden={!open}>
        {children}
      </div>
    </>
  )
}
